import { render, staticRenderFns } from "./BookChapters.vue?vue&type=template&id=389af657&"
import script from "./BookChapters.vue?vue&type=script&lang=js&"
export * from "./BookChapters.vue?vue&type=script&lang=js&"
import style0 from "./BookChapters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports